export const hasRoles = (context, roles) => {
  const contextRoles = context.roles;

  for (let i = 0; i < contextRoles.length; i++) {
    const contextRole = contextRoles[i];
    if (roles.includes(contextRole)) return true;
  }

  return false;
};

export const mergeRoles = (...roles) => {
  const mergedRoles = new Set();

  roles.forEach((role) => {
    role.forEach((r) => {
      mergedRoles.add(r);
    });
  });

  return Array.from(mergedRoles);
};

export const RESEARCH_ASSISTANTS = 'clinease_role_research_assistants';
export const RESEARCH_NURSES_AND_DOCTORS = 'clinease_role_research_nurses_and_doctors';
export const STUDY_COORDINATORS = 'clinease_role_study_coordinators';
export const CLINIC_ADMINISTRATORS = 'clinease_role_clinic_administrators';
export const PROJECT_MANAGERS = 'clinease_role_project_managers';
export const INVESTIGATORS = 'clinease_role_investigators';
export const DATA_CAPTURERS = 'clinease_role_data_capturers';
export const DATA_MANAGERS = 'clinease_role_data_managers';
export const QUALITY_OFFICERS = 'clinease_role_qc_quality_officers';
export const QUALITY_MANAGERS = 'clinease_role_quality_managers';
export const DATA_MONITORS = 'clinease_role_data_monitors';
export const LAB_STAFF = 'clinease_role_lab_staff';
export const PHARMACY_STAFF = 'clinease_role_pharmacy_staff';
export const CLINEASE_ADMINISTRATOR = 'clinease_role_administrators';

export const ALL_ROLES = Object.freeze([
  RESEARCH_ASSISTANTS,
  RESEARCH_NURSES_AND_DOCTORS,
  STUDY_COORDINATORS,
  CLINIC_ADMINISTRATORS,
  PROJECT_MANAGERS,
  INVESTIGATORS,
  DATA_CAPTURERS,
  DATA_MANAGERS,
  QUALITY_OFFICERS,
  QUALITY_MANAGERS,
  DATA_MONITORS,
  LAB_STAFF,
  PHARMACY_STAFF,
  CLINEASE_ADMINISTRATOR,
]);

export const VIEW_QUALITY_CONTROL_DASHBOARD_ROLES = Object.freeze([
  RESEARCH_ASSISTANTS,
  RESEARCH_NURSES_AND_DOCTORS,
  STUDY_COORDINATORS,
  CLINIC_ADMINISTRATORS,
  PROJECT_MANAGERS,
  INVESTIGATORS,
  DATA_CAPTURERS,
  DATA_MANAGERS,
  QUALITY_OFFICERS,
  QUALITY_MANAGERS,
  DATA_MONITORS,
  LAB_STAFF,
  PHARMACY_STAFF,
]);

export const VIEW_DATA_MANAGEMENT_DASHBOARD_ROLES = Object.freeze([
  STUDY_COORDINATORS,
  PROJECT_MANAGERS,
  INVESTIGATORS,
  DATA_CAPTURERS,
  DATA_MANAGERS,
  QUALITY_MANAGERS,
  DATA_MONITORS,
]);

export const CREATE_STUDY_ROLES = Object.freeze([DATA_MANAGERS]);
export const VIEW_STUDY_ROLES = Object.freeze([DATA_MANAGERS]);
export const EDIT_STUDY_ROLES = Object.freeze([DATA_MANAGERS]);

export const CREATE_FORM_ROLES = Object.freeze([DATA_CAPTURERS, DATA_MANAGERS]);
export const VIEW_FORM_ROLES = Object.freeze([
  DATA_CAPTURERS,
  DATA_MANAGERS,
  QUALITY_OFFICERS,
  QUALITY_MANAGERS,
  DATA_MONITORS,
]);
export const EDIT_FORM_ROLES = Object.freeze([DATA_CAPTURERS, DATA_MANAGERS]);

export const CREATE_PARTICIPANT_ROLES = Object.freeze([
  RESEARCH_ASSISTANTS,
  STUDY_COORDINATORS,
  CLINIC_ADMINISTRATORS,
  DATA_CAPTURERS,
  DATA_MANAGERS,
]);
export const VIEW_PARTICIPANT_ROLES = Object.freeze([
  RESEARCH_NURSES_AND_DOCTORS,
  PROJECT_MANAGERS,
  INVESTIGATORS,
  QUALITY_OFFICERS,
  QUALITY_MANAGERS,
  DATA_MONITORS,
]);
export const EDIT_PARTICIPANT_ROLES = Object.freeze([
  RESEARCH_ASSISTANTS,
  STUDY_COORDINATORS,
  CLINIC_ADMINISTRATORS,
  DATA_CAPTURERS,
  DATA_MANAGERS,
]);

export const CREATE_CLIENT_ROLES = Object.freeze([
  RESEARCH_ASSISTANTS,
  STUDY_COORDINATORS,
  CLINIC_ADMINISTRATORS,
  DATA_CAPTURERS,
  DATA_MANAGERS,
]);
export const VIEW_CLIENT_ROLES = Object.freeze([
  RESEARCH_NURSES_AND_DOCTORS,
  PROJECT_MANAGERS,
  INVESTIGATORS,
  QUALITY_OFFICERS,
  QUALITY_MANAGERS,
  DATA_MONITORS,
]);
export const EDIT_CLIENT_ROLES = Object.freeze([
  RESEARCH_ASSISTANTS,
  STUDY_COORDINATORS,
  CLINIC_ADMINISTRATORS,
  DATA_CAPTURERS,
  DATA_MANAGERS,
]);

export const CREATE_PARTICIPANT_REVIEW_ROLES = Object.freeze([
  DATA_CAPTURERS,
  DATA_MANAGERS,
  QUALITY_OFFICERS,
  QUALITY_MANAGERS,
  DATA_MONITORS,
]);
export const VIEW_PARTICIPANT_REVIEW_ROLES = Object.freeze([]);
export const EDIT_PARTICIPANT_REVIEW_ROLES = Object.freeze([
  PROJECT_MANAGERS,
  DATA_CAPTURERS,
  DATA_MANAGERS,
  QUALITY_OFFICERS,
  QUALITY_MANAGERS,
  DATA_MONITORS,
]);
export const QUERY_RESPONSE_ROLES = Object.freeze([
  RESEARCH_ASSISTANTS,
  RESEARCH_NURSES_AND_DOCTORS,
  STUDY_COORDINATORS,
  CLINIC_ADMINISTRATORS,
  PROJECT_MANAGERS,
  INVESTIGATORS,
  DATA_CAPTURERS,
  DATA_MANAGERS,
  QUALITY_OFFICERS,
  QUALITY_MANAGERS,
  DATA_MONITORS,
  LAB_STAFF,
  PHARMACY_STAFF,
]);

export const EDIT_QUERY_RESPONSE_ONLY_ROLES = Object.freeze([
  RESEARCH_ASSISTANTS,
  RESEARCH_NURSES_AND_DOCTORS,
  STUDY_COORDINATORS,
  CLINIC_ADMINISTRATORS,
  PROJECT_MANAGERS,
  INVESTIGATORS,
  LAB_STAFF,
  PHARMACY_STAFF,
]);

export const CREATE_CAPA_REVIEW_ROLES = Object.freeze([
  RESEARCH_NURSES_AND_DOCTORS,
  STUDY_COORDINATORS,
  PROJECT_MANAGERS,
  INVESTIGATORS,
  DATA_MANAGERS,
  QUALITY_OFFICERS,
  QUALITY_MANAGERS,
  DATA_MONITORS,
  LAB_STAFF,
  PHARMACY_STAFF,
]);
export const VIEW_CAPA_REVIEW_ROLES = Object.freeze([
  RESEARCH_ASSISTANTS,
  RESEARCH_NURSES_AND_DOCTORS,
  STUDY_COORDINATORS,
  CLINIC_ADMINISTRATORS,
  PROJECT_MANAGERS,
  INVESTIGATORS,
  DATA_CAPTURERS,
  DATA_MANAGERS,
  QUALITY_OFFICERS,
  QUALITY_MANAGERS,
  DATA_MONITORS,
  LAB_STAFF,
  PHARMACY_STAFF,
]);
export const EDIT_CAPA_REVIEW_ROLES = Object.freeze([
  RESEARCH_NURSES_AND_DOCTORS,
  STUDY_COORDINATORS,
  PROJECT_MANAGERS,
  INVESTIGATORS,
  DATA_MANAGERS,
  QUALITY_OFFICERS,
  QUALITY_MANAGERS,
  DATA_MONITORS,
  LAB_STAFF,
  PHARMACY_STAFF,
]);

export const VIEW_REPORTS_ROLES = Object.freeze([
  STUDY_COORDINATORS,
  INVESTIGATORS,
  DATA_MANAGERS,
  QUALITY_OFFICERS,
  QUALITY_MANAGERS,
  DATA_MONITORS,
  PROJECT_MANAGERS,
]);
export const DOWNLOAD_REPORTS_ROLES = Object.freeze([
  STUDY_COORDINATORS,
  INVESTIGATORS,
  DATA_MANAGERS,
  QUALITY_OFFICERS,
  QUALITY_MANAGERS,
  PROJECT_MANAGERS,
  DATA_MONITORS,
]);

export const VIEW_USERS_ROLES = Object.freeze([DATA_MANAGERS, QUALITY_MANAGERS, CLINEASE_ADMINISTRATOR, DATA_MONITORS]);
export const EDIT_USER_SITES_ROLES = Object.freeze([
  DATA_MANAGERS,
  QUALITY_MANAGERS,
  CLINEASE_ADMINISTRATOR,
  DATA_MONITORS,
]);

export const VIEW_FACILITIES_ROLES = Object.freeze([CLINEASE_ADMINISTRATOR]);
export const EDIT_FACILITIES_ROLES = Object.freeze([CLINEASE_ADMINISTRATOR]);

export const VIEW_SECURITY_QUESTION_ROLES = Object.freeze([DATA_MANAGERS, CLINEASE_ADMINISTRATOR]);
export const EDIT_SECURITY_QUESTION_ROLES = Object.freeze([DATA_MANAGERS, CLINEASE_ADMINISTRATOR]);

export const VIEW_QUERY_COMMENTS_ROLES = Object.freeze([DATA_MANAGERS, CLINEASE_ADMINISTRATOR]);
export const EDIT_QUERY_COMMENTS_ROLES = Object.freeze([DATA_MANAGERS, CLINEASE_ADMINISTRATOR]);

export const VIEW_NOTIFICATION_SETTINGS_ROLES = Object.freeze([DATA_MANAGERS, CLINEASE_ADMINISTRATOR]);
export const EDIT_NOTIFICATION_SETTINGS_ROLES = Object.freeze([DATA_MANAGERS, CLINEASE_ADMINISTRATOR]);

export const roleDisplayValueMap = new Map();
roleDisplayValueMap.set(RESEARCH_ASSISTANTS, 'Research Assistants');
roleDisplayValueMap.set(RESEARCH_NURSES_AND_DOCTORS, 'Research Nurses and Doctors');
roleDisplayValueMap.set(STUDY_COORDINATORS, 'Study Coordinators');
roleDisplayValueMap.set(CLINIC_ADMINISTRATORS, 'Clinic Administrators');
roleDisplayValueMap.set(PROJECT_MANAGERS, 'Project Managers');
roleDisplayValueMap.set(INVESTIGATORS, 'Investigators');
roleDisplayValueMap.set(DATA_CAPTURERS, 'Data Capturers');
roleDisplayValueMap.set(DATA_MANAGERS, 'Data Managers');
roleDisplayValueMap.set(QUALITY_OFFICERS, 'Quality Officers');
roleDisplayValueMap.set(QUALITY_MANAGERS, 'Quality Managers');
roleDisplayValueMap.set(DATA_MONITORS, 'Data Monitors');
roleDisplayValueMap.set(LAB_STAFF, 'Lab Staff');
roleDisplayValueMap.set(PHARMACY_STAFF, 'Pharmacy Staff');
roleDisplayValueMap.set(CLINEASE_ADMINISTRATOR, 'Clinease Administrators');
